import { supabase } from '@/lib/supabase'
import { fetchAllPaged } from '@/lib/fetchAllPaged'
import { toCSV } from '@/lib/csv'
import type { Run } from '@/types/database'

// U17 D1: the header Export reads EVERY verified run itself. It used to export
// whatever the register had loaded (90 days, the status chip, the search) while
// the button said "all verified runs".
const VERIFIED_RUNS_HEADERS = [
  'run_number','grower','variety','puc','status',
  'tipped_net_kg','packed_kg','reject_kg','waste_kg','packout_percent','pallet_count',
  'started_at','tipping_stopped_at','completed_at','verified_at',
]

export function verifiedRunsCsv(rows: Run[]): string {
  return toCSV(VERIFIED_RUNS_HEADERS, rows, r => [
    r.run_number, r.grower, r.variety, r.puc, r.status,
    r.tipped_net_weight_kg, r.packed_weight_kg, r.reject_weight_kg, r.waste_weight_kg,
    r.packout_percent, r.pallet_count,
    r.started_at, r.tipping_stopped_at, r.completed_at, r.verified_at,
  ])
}

export const verifiedRunsFileName = (stamp: string) => `verified-runs-all-history-${stamp}.csv`

/** Every verified run of the business (no date window, no chip, no search). Throws on a failed read. */
export async function fetchAllVerifiedRuns(): Promise<Run[]> {
  const { rows, error } = await fetchAllPaged<Run>((from, to) =>
    supabase.from('runs').select('*')
      .is('deleted_at', null)
      .neq('run_kind', 'EXTERNAL_RECEIPT')
      .not('verified_at', 'is', null)
      .order('started_at', { ascending: false })
      .order('run_id')
      .range(from, to) as unknown as PromiseLike<{ data: Run[] | null; error: { message: string } | null }>,
    { maxRows: 50_000 })
  if (error) throw new Error(error)
  return rows
}
